import { render, staticRenderFns } from "./OMinisterio.vue?vue&type=template&id=01c57bf4&scoped=true&"
import script from "./OMinisterio.vue?vue&type=script&lang=js&"
export * from "./OMinisterio.vue?vue&type=script&lang=js&"
import style0 from "./OMinisterio.vue?vue&type=style&index=0&id=01c57bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c57bf4",
  null
  
)

export default component.exports